// maxPage           - количество страниц
// currentPageNumber - выбранная страница на текущий момент
// offset            - количество показываемых кнопок пагинации рядом с текущей выбранной(либо будет заменяться на стрелки)

export const useCalcOffsetPagination = (maxPage, currentPageNumber, offset) => {
    if (maxPage < offset * 2) {
        return { min: 1, max: maxPage, position: 'center' }
    }

    let min = null
    let max = null
    let position = null
    if (currentPageNumber - offset < 1) {
        min = 1
        max = offset * 2
        position = 'left'
    } else if (currentPageNumber + offset >= maxPage - 1) {
        min = maxPage - offset * 2 + 1
        max = maxPage
        position = 'right'
    } else {
        min = currentPageNumber - offset
        max = currentPageNumber + offset
        position = 'center'
    }
    return { min, max, position }
}
